<ng-container *transloco="let t">
    @if (competitor && key) {
    @if (fieldType === 'general') {
    @switch (key) {
    @case ('startNumber') {
    @let startNumber = competitor.startNumber ?? '00';
    @if (showAsPlain) {
    {{ startNumber }}
    } @else {
    <span [class.opacity-25]="!competitor.startNumber">{{ startNumber }}</span>
    }
    }
    @case ('startBlock') {
    @let startBlock = competitor.startBlock ?? '00';
    @if (showAsPlain) {
    {{ startBlock }}
    } @else {
    <span [class.opacity-25]="!competitor.startBlock">{{ startBlock }}</span>
    }
    }
    @case ('status') {
    @let status = competitor.status ? competitor.status : "-";
    @if (showAsPlain) {
    {{ status }}
    } @else {
    <div class="d-flex">
        <div class="badge-holder__badge finished">
            <span class="text-uppercase">{{ status }}</span>
                            </div>
                        </div>
    }
    }
    @case ('paymentStatus') {
    @let hasPaymentStatus = competitor.paymentStatus !== null && competitor.paymentStatus !== undefined;
    @let paymentStatusText = hasPaymentStatus ?
    t("account.statements.amountStatus." + competitor.paymentStatus + (!isAdmin && competitor.paymentStatus === AmountStatus.EXACT ? ".public" : ""))
    : '-';
    @if (showAsPlain) {
    {{ paymentStatusText }}
    } @else {
    <div class="d-flex">
        @if (hasPaymentStatus) {
    <div class="badge-holder__badge no-border"
         [class.finished]="competitor.paymentStatus === AmountStatus.EXACT"
         [class.underpaid]="competitor.paymentStatus === AmountStatus.UNDERPAID"
         [class.overpaid]="competitor.paymentStatus === AmountStatus.OVERPAID"
         [class.to-be-started]="competitor.paymentStatus === AmountStatus.NOT_PAID">
        <span class="text-uppercase">{{ paymentStatusText }}</span>
    </div>
    } @else {
    {{ paymentStatusText }}
    }
    </div>
    }
    }
    @case ('created') {
    {{ competitor.created ?? '' | localizedDate:'shortDate' }}
    }
    @case ('modified') {
    {{ competitor.modified ?? '' | localizedDate:'short' }}
    }
    @case ('birthday') {
    {{ competitor.birthday ?? '' | localizedDate:'shortDate' }}
    }
    @case ('identityCardExpires') {
    {{ competitor.identityCardExpires ?? '' | localizedDate:'shortDate' }}
    }
    @case ('country') {
    {{ competitor.countryShort ?? '-' }}
    }
    @case ('startTime') {
    {{
    competitor.startTime
        ? (competitor.startTime | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS')
        : '-'
    }}
    }
    @case ('fee') {
    @let commercialItem = competitor.raceCommercialItemValue;
    @let feeText = commercialItem || competitor.fee || '-';
    @if (showAsPlain) {
    {{ feeText }}
    } @else {
    <span class="d-flex align-items-center">
        @if (commercialItem) {
    <div class="text-truncate" style="min-width: 0;"
         [ngbTooltip]="showTooltip ? commercialItem : null">
        {{ commercialItem }}
    </div>
    @if (competitor.fee) {
    <i class="bi bi-info-circle info-icon ps-2"
        [ngbTooltip]="showTooltip ? competitor.fee : null"
        ></i>
    }
    } @else {
    <div class="text-truncate" style="min-width: 0;"
         [ngbTooltip]="showTooltip ? feeText : null">
        {{ feeText }}
    </div>
    }
    </span>
    }
    }
    @case ('sex') {
    @let hasSex = !!competitor.sex;
    @let sexText = hasSex ? t('app.common.gender.short.' + competitor.sex) : '-';
    @if (showAsPlain) {
    {{ sexText }}
    } @else {
    <div class="d-flex justify-content-center">
        @if (hasSex) {
    <div class="badge-holder__badge" [ngClass]="{
                                    'gender-badge-man': competitor.sex !== 2,
                                    'gender-badge-women': competitor.sex === 2
                                }">
        <span class="text-uppercase">{{ sexText }}</span>
    </div>
    }
    </div>
    }
    }
    @default {
    @let defaultText = ($any(competitor)?.[key]) ?? "-";
    @if (showAsPlain) {
    {{ defaultText }}
    } @else {
    <span class="text-truncate" [ngbTooltip]="showTooltip ? defaultText : null">
    {{ defaultText }}
    </span>
    }
    }
    }
    }
    @if (fieldType === 'custom') {
    {{ competitor.customFields?.get(key) ?? '-' }}
    }
    @if (fieldType === 'pricing') {
    {{ competitor.raceAdditionalItems?.get(key) ?? '-' }}
    }
    }
</ng-container>